import styled from 'styled-components';
import { colors } from "../../utils/colors";
import background from '../../assets/home/darkblue-footer-background.png';

export const Navigation = styled.div`
    position: absolute;
    left: 0;
    top: -1px;
    width: 100vw;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100px;
    padding: 0 60px;
    background: ${(props) => (props.single === true) ? `url(${background})` : 'transparent'};
    background-repeat: no-repeat;
    background-size: cover;
    
    @media (max-width: 1200px) {
        padding: 0 40px;
    }

    @media (max-width: 800px) {
        padding: 0 20px;
    }
`;

export const HeaderItemWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const HeaderItem = styled.p`
    color: ${props => props.blue ? colors.BLUE : 'white'};
    margin: 0 10px;
    text-transform: uppercase;
    text-align: center;
    transition: 200ms cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
        cursor: pointer;
        color: ${colors.CREAM};
    }
`;

export const Img = styled.img`
    width: ${(props) => props.small ? '35px' : '150px'}
`;